<template>
    <!-- 兑换活动管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'exchangeGift')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="礼券名称">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="兑换商品分类">
                        <a-select allowClear placeholder="请选择" v-decorator="['goodCategory']" @select="search">
                            <a-select-option value="1">线上票</a-select-option>
                            <a-select-option value="2">线下票</a-select-option>
                            <a-select-option value="3">优惠券</a-select-option>
                            <a-select-option value="4">储值</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="展示名称">
                        <a-input placeholder="请输入" v-decorator="['goodName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="内部标识">
                        <a-input placeholder="请输入" v-decorator="['goodInnerName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="兑换有效期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY－MM－DD"
                            v-decorator="['validity']"
                            @change="search"
                        />
                    </a-form-item>
                    <a-form-item label="是否企业团购">
                        <a-select allowClear placeholder="请选择" v-decorator="['isGroupBuy']" @select="search">
                            <a-select-option value="0">否</a-select-option>
                            <a-select-option value="1">是</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="兑换礼券状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['status']" @select="search">
                            <a-select-option value="-1">停用</a-select-option>
                            <a-select-option value="0">正常</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <a-button slot="extra" v-if="getBtnByAuth('exchangeGiftAdd')" type="primary" @click="toAddCode">新建兑换礼券</a-button>
                <a-table
                :scroll="{y: 590}"
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="record => record.id"
                >
                <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                <span slot="goodCategory" slot-scope="goodCategory">{{['','线上票','线下票','优惠券','储值卡'][goodCategory]}}</span>
                <span slot="isGroupBuy" slot-scope="isGroupBuy">{{['否','是'][isGroupBuy]}}</span>
                <span slot="status" slot-scope="status">{{status == -1 ? '停用' : '正常'}}</span>
                <span slot="num" slot-scope="num">{{num ? num.toLocaleString() : 0}}</span>
                <span slot="startExpiryDate" slot-scope="a,row">{{row.isHasExpiryDate == 1 ? (row.startExpiryDate + '~' + row.endExpiryDate) : '不限期'}}</span>
                <span slot="action" slot-scope="a,row">
                    <a v-if="getBtnByAuth('exchangeGiftDelete') && row.status == -1" class="text-primary" @click="toDelete(row)">删除</a>
                    <span class="text-disabled" v-else>删除</span>
                    <a-divider type="vertical"/>
                    <span v-if="getBtnByAuth('exchangeGiftEdit')">
                        <a v-if="row.status == -1" class="text-primary" @click="toUpdateStore(row.id)">编辑</a>
                        <span class="text-disabled" v-else>编辑</span>
                        <a-divider type="vertical"/>
                    </span>
                    <a v-if="getBtnByAuth('exchangeGiftStatus')" class="text-primary" @click="toUpdateStatus(row.id, row.status)">{{row.status == -1 ? '启用' : '停用'}}<a-divider type="vertical"/></a>
                    <a v-if="getBtnByAuth('exchangeGiftDetail')" class="text-primary" @click="toDetail(row.id)">详情</a>
                </span>
                </a-table>
            </a-card>
            <a-modal :title="operateTitle" centered v-model="visable" @cancel="visable = false; remark = undefined">
                <a-alert :message="warningText" banner />
                <a-row class="mt16">
                    <a-col :span="3"><span class="text-fail">*</span> 备注：</a-col>
                    <a-col :span="21"><a-textarea v-model="remark" placeholder="请输入备注" /></a-col>
                </a-row>
                <template slot="footer">
                    <a-button @click="visable = false; remark = undefined">
                    取消
                    </a-button>
                    <a-button type="primary" :disabled="!remark" :loading="btnLoading" @click="handleOk">
                    确定
                    </a-button>
                </template>
            </a-modal>
            <common-tips ref="commonTips">
                <template slot="context">
                    <div class="mb8"><a-icon type="info-circle" theme="filled" style="color: #F59A23;" /><span class="ml8">此礼券已有用户兑换，不能删除！！</span></div>
                </template>
            </common-tips>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import CommonTips from '@/components/common/common-tips.component'
    const columns = [
            {
                title: "ID",
                dataIndex: "id"
            },
            {
                title: "礼券名称",
                dataIndex: "name"
            },
            {
                title: "兑换商品分类",
                dataIndex: "goodCategory",
                scopedSlots: { customRender: "goodCategory" }
            },
            {
                title: "展示名称",
                dataIndex: "goodName"
            },
            {
                title: "内部标识",
                dataIndex: "goodInnerName"
            },
            {
                title: "生成数量",
                dataIndex: "num",
                scopedSlots: { customRender: "num"}
            },
            {
                title: "兑换数量",
                dataIndex: "cashNum",
                scopedSlots: { customRender: "num"}
            },
            {
                title: "兑换有效期",
                dataIndex: "startExpiryDate",
                scopedSlots: { customRender: "startExpiryDate" }
            },
            {
                title: "是否企业团购",
                dataIndex: "isGroupBuy",
                scopedSlots: { customRender: "isGroupBuy"}
            },
            {
                title: "状态",
                dataIndex: "status",
                scopedSlots: { customRender: "status"}
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }
        ];
    export default {
        name: "exchangeGift",
        components: {
            CommonTips
        },
        props: {},
        data() {
            return {
                cityList: [],
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                operateTitle: '',
                warningText: '',
                remark: undefined,
                visable: false,
                btnLoading: false,
                operateParams: {}
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['validity'] ? values['validity'] : []
                    values.startExpiryDate = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : undefined
                    values.endExpiryDate = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : undefined
                    delete values.validity
                    this.$api.changeCode
                    .exchangeGiftList({
                        query: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    });
                });
            },

            // 跳转至新增页
            toAddCode() {
                this.$router.push({
                    name: "exchangeGiftAdd",
                });
            },

            // 跳转至编辑
            toUpdateStore(id) {
                this.$router.push({
                    name: "exchangeGiftEdit",
                    query: { id: id}
                });
            },

            // 跳转至详情
            toDetail(id) {
                this.$router.push({
                    name: "exchangeGiftDetail",
                    query: { id: id}
                });
            },
            toDelete(row) {
                console.log(row)
                if (row.status == 0 || row.isUse == 1) {
                    this.$refs.commonTips.open();
                    return;
                }
                this.visable = true;
                this.operateTitle = '删除';
                this.warningText = '删除操作，将释放兑换物品库存，已下载的资源将失效';
                this.operateParams = {id: row.id};
            },
            toUpdateStatus(id, status) {
                this.visable = true;
                this.operateTitle = status == -1 ? '启用' : '停用';
                this.warningText = this.operateTitle + '操作，未兑换的兑换码将' + (status == -1 ? '继续可兑' : '无法兑换');
                this.operateParams = {id: id, isOpen: status == -1 ? 1 : 0 };
            },
            handleOk() {
                this.operateParams.remark = this.remark;
                this.btnLoading = true;
                this.$api.changeCode[this.operateTitle == '删除' ? 'exchangeGiftDelete' : 'disableOrOpen']({
                    query: this.operateParams
                }).then(res => {
                    this.btnLoading = false;
                    this.visable = false;
                    this.remark = undefined;
                    this.getList();
                    //if(res.flag) {
                        this.$message.success('操作成功');
                    //}else {
                    //    this.$message.warning(res.msg);
                    //}
                }).catch(err => {
                    this.btnLoading = false;
                })
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList()
        },
        watch: {
            $route(val) {
                val.name == "exchangeGift" && this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>
